import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function CSWhatIs() {
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-642">
      <div className="max-w-[800px] mx-auto px-6 lg:px-8" data-id="element-643">
        <AnimateOnScroll className="text-center flex flex-col items-center" data-id="element-644">
          <h2 className="text-[26px] lg:text-[40px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-645">
            WHAT IS A LASER FACIAL?
          </h2>

          <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-646"></div>

          <p className="text-black text-lg leading-[1.8] font-body mb-12" data-id="element-647">
            A laser facial, also known as laser skin resurfacing or laser skin
            rejuvenation, is a cosmetic procedure that uses laser technology to
            improve the appearance and texture of the skin.
          </p>

          <div className="relative max-w-[700px] mx-auto mb-12" data-id="element-648">
            <div className="text-[#FF1493] text-[60px] font-serif leading-none select-none opacity-60 mb-2" data-id="element-649">
              &ldquo;
            </div>
            <p className="font-serif italic text-black text-lg lg:text-[22px] leading-[1.6]" data-id="element-650">
              Got a party to attend or a family gathering? Or just a special
              date? A ClearSilk Laser Facial will make you love your reflection!
            </p>
          </div>

          <div className="space-y-6 text-[#333333] text-[17px] leading-[1.8] font-body" data-id="element-651">
            <p data-id="element-652">
              At Be CLINICAL, we offer ClearSilk, a non-ablative laser
              treatment. This type of treatment is popular because it does not
              remove the outer layer of skin (epidermis) — there is no downtime.
              Instead, it delivers targeted energy beneath the skin's surface to
              stimulate collagen production and promote skin tightening.
            </p>
            <p data-id="element-653">
              Non-ablative lasers work by creating controlled thermal injury in
              the deeper layers of the skin, triggering the body's natural
              healing response and leading to the production of new, healthier
              skin cells. Unlike ablative lasers, non-ablative lasers typically
              have minimal downtime and are suitable for a wider range of skin
              types and concerns.
            </p>
          </div>
        </AnimateOnScroll>
      </div>
    </section>;
}